// extracted by mini-css-extract-plugin
export default {"student-name":"styles_student-name__f0DBd","student-age":"styles_student-age__Yb-Y8"};